export const environment = {
  production: true,
  appPrefix: 'scv3-app',
  apiPrefix: 'scv3-api',
  apiUrl: 'https://scv3-api.scdevelopment.dev/v1.1',
  gqlUrl: 'https://scv3-api.scdevelopment.dev/GraphQL',
};
